<script>
export default {
  name: 'PageTitle',
  props: {
    bigTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    numberTitle: {
      type: Number,
      default: null,
    },
    bgImage: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div class="home-guide">
    <div class="guide-content" :style="`background-image: url('${bgImage}');`">
      <h2 class="guide-title">
        {{ title }}<span class="guide-number">{{ numberTitle }}</span>
      </h2>
      <h3 class="guide-sub-title">{{ subTitle }}</h3>
      <div class="guide-img">
        <img :src="`${image}`" alt="guide img" />
      </div>
      <div class="guide-desc">
        <p class="text" v-html="description"></p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'home-guide.scss';
</style>
